import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Typography, useEventCallback } from '@mui/material';
import { memo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import CivilUnionForm from './form';
import {
  NewPersonVM,
  AccordionCivilUnion,
} from 'shell/components/shared/sipo-person-form/new-person';

const CivilUnionComponent = (): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(false);

  const formContext = useFormikContext<NewPersonVM>();

  const onFieldCivilUnionChange = useEventCallback(
    (key: keyof AccordionCivilUnion, value: AccordionCivilUnion[keyof AccordionCivilUnion]) => {
      formContext.setFieldValue('civilUnion', {
        ...(formContext.values.civilUnion || {}),
        [key]: value,
      });
    }
  );

  const onFieldsCivilUnionChange = useEventCallback((values: AccordionCivilUnion) => {
    formContext.setFieldValue('civilUnion', {
      ...formContext.values.civilUnion,
      ...values,
    });
  });

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-civil-union-content"
        id="panel-person-civil-union-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>
          Unione Civile
          {formContext?.errors?.civilUnion && formContext?.touched?.civilUnion ? (
            <Typography style={{ color: '#d6012e', display: 'inline', paddingLeft: '10px' }}>
              Attenzione verificare dati errati o mancanti
            </Typography>
          ) : undefined}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <CivilUnionForm
          values={formContext.values.civilUnion}
          onChange={onFieldCivilUnionChange}
          onFieldsChange={onFieldsCivilUnionChange}
          errors={formContext.errors.civilUnion as FormikErrors<AccordionCivilUnion>}
          touched={formContext.touched.civilUnion as unknown as FormikTouched<AccordionCivilUnion>}
        />
      </AccordionDetails>
    </Accordion>
  );
};

CivilUnionComponent.displayName = 'Accordion civil union component';

const CivilUnion = memo(CivilUnionComponent);

export default CivilUnion;
